import {
  ActivityEnrollableTimesModal_ActivityFragment,
  ClassDetailsQuery_ActivityFragment,
} from "@outschool/gql-frontend-generated";
import { activityPath } from "@outschool/routes";
import { useSession } from "@outschool/ui-auth";
import { useCallback } from "react";

import { useMembershipRequirement } from "../../subscriptions/hooks/useMembershipRequirement";

export default function useEnrollmentUrl() {
  const { isLoggedIn } = useSession();
  const { showCredits } = useMembershipRequirement();

  return useCallback(
    ({
      path,
      activity,
    }: {
      path: string;
      activity:
        | ActivityEnrollableTimesModal_ActivityFragment
        | ClassDetailsQuery_ActivityFragment;
    }) => {
      if (!showCredits) {
        return { newUrl: path };
      }

      const params = new URLSearchParams();
      let redirectAfterPath = path;

      params.set("joinMembershipModal", "true");
      params.set("redirectAfterPath", redirectAfterPath);
      const loginUrl = `${activityPath(activity)}?${params.toString()}`;

      if (isLoggedIn) {
        return {
          newUrl: loginUrl,
        };
      }

      params.set("collectLearnerData", "true");
      const signUpUrl = `${activityPath(activity)}?${params.toString()}`;

      return {
        newUrlAfterSignUp: signUpUrl,
        newUrlAfterLogin: loginUrl,
        shouldNavigateOverwrite: false,
      };
    },
    [showCredits, isLoggedIn],
  );
}
